<template>
<info-widget :collapsible="true" :is-expanded="widgetExpanded" @toggle_expand="widgetExpanded = !widgetExpanded">
    <template v-slot:title>
        <slot name="title"></slot>
    </template>

    <template v-slot:headerbutton>
        <slot name="headerbutton"></slot>
    </template>

    <slot>
        <div class="p-0">
            <div class="row-empty m-2" v-if="sections.length == 1 && sections[0].rows.length < 1">
                This section is empty.
            </div>

            <section class="table-section" v-for="section in sections">

                <a href class="table-section-titlebar collapse-trigger" role="button" :class="{'is-expanded': expandedSections[section.title]}" @click.prevent="expandedSections[section.title] = !expandedSections[section.title]" v-if="sections.length > 1">

                    <span class="widget-toggle-wrapper">
                        <collapse-toggle-button />
                    </span>
                    <h5 class="table-section-title">{{ section.title }} <span class="text-regular">({{ section.rows.length }})</span></h5>
                </a>
                <div class="row-empty" v-if="!section.rows.length && sections.length > 1" v-show="expandedSections[section.title]">
                    This section is empty.
                </div>

                <table class="table css-table widget-table table-fixed mt-1" v-if="section.rows.length" v-show="expandedSections[section.title]">
                    <thead>
                        <tr>
                            <th class="cw-toggle"></th>
                            <th v-for="header in headers">{{ header }}</th>
                        </tr>
                    </thead>
                    <tbody v-for="row in section.rows" :key="row.id" :class="{'active-item': false}">
                        <tr>
                            <td class="cw-toggle position-relative">
                                <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': expandedItems[row.id]}" @click.prevent="expandedItems[row.id] = !expandedItems[row.id]">
                                    <collapse-toggle-button />
                                </a>
                            </td>
                            <td class="truncate-wrapper" v-for="(header, idx) in headers">{{ row.cells[idx] }}</td>
                        </tr>
                        <tr class="child no-transition" v-show="expandedItems[row.id]">
                            <td :colspan="headers.length + 1">
                                <div class="card card-body item-details">

                                    <section class="item-details-section">
                                        <slot name="row-header" :row="row"></slot>
                                    </section>

                                    <section class="item-details-section">
                                        <slot name="row-details" :row="row"></slot>
                                    </section>

                                    <section class="item-details-section">
                                        <slot name="row-action" :row="row"></slot>
                                    </section>

                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>

    </slot>
</info-widget>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'

export default {
    props: ['sections', 'headers', 'startExpanded'],
    components: {InfoWidget, },
    computed: {
    },
    data() {
        const expandedSections = {}
        this.sections.forEach(s => {
            expandedSections[s.title] = (this.sections.length > 1) ? false : true
        })

        return {
            widgetExpanded: this.startExpanded ? true : false,
            expandedSections: expandedSections,
            expandedItems: {},
        }
    },
}
</script>
